import React from 'react'
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input} from 'reactstrap'
import apiBarcode from '../../../services/api/apiBarcode'
import {pushNewItemHistory} from "../../../services/api/apiItemHistory"

class ModalEditProduct extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            product: {},
            isLoadingSave: false,
            loadingUpdate: false
        }
    }

    componentDidMount() {
        this._loadStateFromProps()
    }

    _loadStateFromProps = () => {
        const {product} = this.props
        this.setState({product})
    }

    _handleChangeInput = (e) => {
        const {name, value} = e.target
        const {product} = this.state
        this.setState({product: {...product, [name]: value}})
    }

    _renderIconLoading = () => {
        if (this.state.isLoadingSave)
            return <i className='icon-spinner2 spinner ml-2'/>
    }

    _handleClickSave = async () => {
        this.setState({isLoadingSave: true})

        try {
            const {product: productOld} = this.props
            const {barcodeId: barcodeIdOld, productId: productIdOld, barcodeNumber, pos, ...productWithoutIdOld} = productOld
            const {product} = this.state
            const {barcodeId, productId, barcodeNumber: barcodeNumberNew, pos: posNew, ...productWithoutId} = product

            const diff = this._diff(productWithoutIdOld, productWithoutId)
            let from = []
            let to = []
            diff.forEach(itemDiff => {
                from.push(`${itemDiff}: ${productWithoutIdOld[itemDiff]}`)
                to.push(`${itemDiff}: ${productWithoutId[itemDiff]}`)
            })

            const resUpdated = await apiBarcode.updateBarcodeProduct(barcodeId, productId, productWithoutId)
            const {success, message} = resUpdated.data
            if (!success) throw new Error(message)

            await this.props.reload()
            this.props.toggle()

            return pushNewItemHistory(`${barcodeNumber}_${pos}`, {
                event_key: 'edit_order_item',
                event_description: `Edit item order`,
                event_meta: {
                    from: from.toString(', '),
                    to: to.toString(', '),
                }
            })
        } catch (e) {
            alert(e.message)
        }

        this.setState({isLoadingSave: false})
    }

    _diff = (oldObj, newObj) => {
        return Object.entries(newObj).map(([key, value]) => {
            if (oldObj[key] !== newObj[key]) {
                return key
            }
            return null
        }).filter(Boolean)
    }

    _completedEditDesign = async () => {
        this.setState({
            loadingUpdate: true
        })

        if (window.confirm('Bạn có chắc chắn đánh dấu đã sửa design thành công?')) {
            try {
                const {product} = this.state
                const {barcodeNumber, pos} = product

                const {'data': responsive} = await apiBarcode.updateStatusDesign(barcodeNumber, pos)

                const {success, message} = responsive

                if (!success) {
                    this.setState({
                        loadingUpdate: false
                    })

                    throw new Error(message)
                }

                this.setState({
                    loadingUpdate: false
                }, async () => {
                    await this.props.reload()
                    this.props.toggle()
                })

            } catch (e) {
                this.setState({
                    loadingUpdate: false
                })
                alert(e.message)
            }
        } else {
            this.setState({
                loadingUpdate: false
            })
        }
    }

    render() {
        const {isOpen, toggle} = this.props
        const {isLoadingSave, product, loadingUpdate} = this.state
        const {mockUpFront, mockUpBack, designFront, designBack, size, color, type, designSleeveLeft, designSleeveRight, tags} = product
        const disableEditDesign = tags !== undefined && tags.length > 0 && tags.includes('waiting-update-design')
        const {note} = this.props.product

        return (
            <div>
                <Modal isOpen={isOpen} toggle={toggle} className={this.props.className}>
                    <ModalHeader toggle={toggle}>Sửa Item</ModalHeader>
                    <ModalBody style={{maxHeight:'75vh', overflowY: 'scroll' }}>
                        <FormGroup>
                            <Label className="font-weight-bold">Mock Up Front</Label>
                            <Input name='mockUpFront' value={mockUpFront} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label className="font-weight-bold">Mock Up Back</Label>
                            <Input name='mockUpBack' value={mockUpBack} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label className="font-weight-bold">Design Front</Label>
                            <Input name='designFront' disabled={disableEditDesign} value={designFront} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label className="font-weight-bold">Design Back</Label>
                            <Input name='designBack' disabled={disableEditDesign} value={designBack} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label className="font-weight-bold">Design Sleeve Left</Label>
                            <Input name='designSleeveLeft' disabled={disableEditDesign} value={designSleeveLeft} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label className="font-weight-bold">Design Sleeve Right</Label>
                            <Input name='designSleeveRight' disabled={disableEditDesign} value={designSleeveRight} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label className="font-weight-bold">Size</Label>
                            <Input name='size' value={size} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label className="font-weight-bold">Color</Label>
                            <Input name='color' value={color} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label className="font-weight-bold">Type</Label>
                            <Input name='type' value={type} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label className="font-weight-bold">Note</Label>
                            <Input name='type' value={note} disabled className="text-danger"/>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter className="d-flex justify-content-between align-content-center">
                        <Button color="secondary" onClick={toggle}>Cancel</Button>
                        <div>
                            {
                                product.productStatus === 'false_design' &&
                                <Button className="mr-2" color="danger" onClick={this._completedEditDesign}>
                                    Cập nhật design
                                    {loadingUpdate && <i className='icon-spinner2 spinner ml-2'/>}
                                </Button>
                            }
                            <Button color="primary" onClick={this._handleClickSave} disabled={isLoadingSave}>
                                Save
                                {this._renderIconLoading()}
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default ModalEditProduct
